export default __webpack_public_path__ + "static/media/member3.7f7da674.jpg";